module.exports = __webpack_public_path__ + "static/img/bg_ljcx.7406709.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/member/bg_ljcx.png
// module id = TB4i
// module chunks = 2